import axios, { AxiosProgressEvent, Canceler } from 'axios';
import { generateUuid } from '@lib/uuid';
import { axiosClient } from '@nx-frontend/shared/api/axios';
import { BucketAttachment } from '@nx-frontend/shared/types';

interface UploadBucketAttachmentProps {
  gatewayUrl: string;
  file: File;
  workspaceId: string;
  target: string;
  targetId: string;
  groupId: string;
  sessionId: string | null;
  id?: string;
  onUploadProgress?: (progressEvent: AxiosProgressEvent) => void;
  getCancelToken?: (canceler: Canceler) => void;
}

export const uploadBucketAttachment = async ({
  gatewayUrl,
  file,
  workspaceId,
  groupId,
  target,
  targetId,
  sessionId,
  id,
  onUploadProgress,
  getCancelToken,
}: UploadBucketAttachmentProps): Promise<BucketAttachment> => {
  const formData = new FormData();
  formData.append('file', file);
  const globalId = id ?? generateUuid();
  const response = await axiosClient.post(`${gatewayUrl}/ft:buckets/attachments/${globalId}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    params: {
      workspaceId,
      target,
      targetId,
      groupId,
    },
    sessionId,
    onUploadProgress,
    cancelToken: new axios.CancelToken((canceler) => {
      if (getCancelToken) {
        getCancelToken(canceler);
      }
    }),
  });

  if ('message' in response.data) {
    throw new Error(response.data.message);
  }
  return response.data;
};
